import apiMiddleware from "../api/apiMiddleware";

export const bookings = async () => {
    try {
        const response = await apiMiddleware.get('/booked-packages-supplier');
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}

